export default __webpack_public_path__ + "static/media/CapFusion-MM  PR Announcement 2016 05 31.d61e706b.pdf";